import { FC, useMemo, useState } from "react";
import { ChevronDown, ChevronRight } from "lucide-react";
import { JourneySummary } from "@services/journey/commands/cmdListJourneys";

interface Props {
  journeys: JourneySummary[];
  selectedId: number | null;
  onSelect: (id: number) => void;
  onAddIndustry: () => void;
  onAddJourney: (industry: string) => void;
}

const IndustryRail: FC<Props> = ({ journeys, selectedId, onSelect, onAddIndustry, onAddJourney }) => {
  // Group journeys by their industry label (the rail's "verticals").
  const groups = useMemo(() => {
    const byIndustry = new Map<string, JourneySummary[]>();
    for (const j of journeys) {
      const key = j.industry || "Other";
      const arr = byIndustry.get(key) ?? [];
      arr.push(j);
      byIndustry.set(key, arr);
    }
    return [...byIndustry.entries()];
  }, [journeys]);

  const [collapsed, setCollapsed] = useState<Set<string>>(new Set());
  const toggle = (industry: string) =>
    setCollapsed((prev) => {
      const next = new Set(prev);
      next.has(industry) ? next.delete(industry) : next.add(industry);
      return next;
    });

  return (
    <div className="jsm-rail">
      <div className="jsm-rail-label">INDUSTRIES</div>
      {groups.map(([industry, items]) => {
        const isCollapsed = collapsed.has(industry);
        return (
          <div key={industry}>
            <div className="jsm-rail-industry" onClick={() => toggle(industry)}>
              <span className="jsm-caret">
                {isCollapsed ? <ChevronRight size={16} /> : <ChevronDown size={16} />}
              </span>
              <span className="jsm-industry-name">{industry}</span>
            </div>
            {!isCollapsed && (
              <>
                {items.map((j) => (
                  <div
                    key={j.id}
                    className={`jsm-rail-journey${j.id === selectedId ? " is-selected" : ""}`}
                    onClick={() => onSelect(j.id)}
                  >
                    {j.name}
                  </div>
                ))}
                <div className="jsm-rail-add-journey" onClick={() => onAddJourney(industry)}>
                  ＋ Add journey
                </div>
              </>
            )}
          </div>
        );
      })}
      <div className="jsm-rail-add-industry" onClick={onAddIndustry}>＋ Add industry</div>
    </div>
  );
};

export default IndustryRail;
